import { defineStore } from 'pinia'
import api from '@/plugins/api'
import { notify } from "@kyvg/vue3-notification"
import router from '@/router' // Импортируем роутер

export const useUserStore = defineStore('user', {
  state: () => ({
    auth: false,
    data: {},
    loyalty: {},
  }),
  getters: {
    getFullName: (state) => {
      if (state.data && state.data.name && state.data.family) {
        return `${state.data.name} ${state.data.family}`
      }
      
      return '';
    },
    getUserId: (state) => state.data.id,
    getUserCard: (state) => state.loyalty,
  },
  actions: {
    logout() {
      api.defaults.headers['sessionid'] = null
      localStorage.sessionId = null

      this.data = {}
      this.auth = false

      notify({
        title: 'Успех',
        text: 'Вы успешно вышли из аккаунта',
        type: 'success',
      })

      // Редирект на главную только если находимся в разделе /lk/
      if (router.currentRoute.value.path.startsWith('/lk/') && !router.currentRoute.value.path.startsWith('/lk/loyalty/')) {
        router.push('/')
      }
    },
  },
});